import { Box, Tooltip } from '@mui/material';

export function zollProofIncomplete(row: {
  melt_country_id?: number | null;
  heat_number?: string | null;
}): boolean {
  return row.melt_country_id == null || !(row.heat_number || '').trim();
}

export default function ZollIncompleteMark() {
  return (
    <Tooltip title="Für ein Zollzeugnis fehlen Schmelzland oder Schmelznummer">
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          borderRadius: 999,
          px: 1,
          py: 0.15,
          bgcolor: '#fef3c7',
          color: '#a16207',
          fontSize: 12,
          fontWeight: 500,
          lineHeight: 1.4,
          whiteSpace: 'nowrap',
        }}
      >
        Zoll unvollständig
      </Box>
    </Tooltip>
  );
}
